import { brandConfig } from '../brandConfig';

// Hijra Tours mock data
export const COMPANY = {
  name: brandConfig.companyName,
  arabicName: 'هجرة تورز',
  tagline: 'Your Journey. Our Responsibility.',
  taglineSub: 'Spirituality. Comfort. Trust.',
  motto: 'A Journey of Faith, A Lifetime of Blessings',
  arabicMotto: 'رحلة إيمان وعمر من البركات',
  phone: '0983848544',
  phone2: '0977777161',
  phoneIntl: '+251983848544',
  phoneDisplay: '0983 848 544 / 0977 777 161',
  whatsapp: '+251983848544',
  email: brandConfig.contactEmail,
  social: {
    tiktok: 'https://www.tiktok.com/@hijratravel',
    instagram: brandConfig.instagramLink,
    facebook: brandConfig.facebookLink,
  },
  location: 'Addis Ababa, Ethiopia',
  locationAr: 'أديس أبابا، إثيوبيا',
  hours: '24/7 Support',
  bismillah: 'بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ',
};

// Verified working image URLs (Unsplash + Pexels)
const IMG = {
  kaabaDay: 'https://images.unsplash.com/photo-1592326871020-04f58c1a52f3?w=800&h=600&fit=crop&q=80',
  kaabaNight: 'https://images.unsplash.com/photo-1513072064285-240f87fa81e8?w=800&h=600&fit=crop&q=80',
  nabawi: 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=800&h=600&fit=crop&q=80',
  pilgrims: 'https://images.unsplash.com/photo-1564769625905-50e93615e769?w=800&h=600&fit=crop&q=80',
  mosqueInterior: 'https://images.unsplash.com/photo-1574246604907-db69e30ddb97?w=800&h=600&fit=crop&q=80',
  meccaNight: 'https://images.pexels.com/photos/34999018/pexels-photo-34999018.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop',
};

export const PACKAGES = [
  {
    id: 1,
    name: 'Economy Umrah Package',
    arabic: 'باقة العمرة الاقتصادية',
    type: 'Umrah',
    duration: '15 Days',
    description: 'Complete 15-day Umrah package from Addis Ababa. Visa, round-trip ticket, hotel in Mecca & Medina, transport and meals included.',
    price: 'ETB 165,000',
    image: IMG.nabawi,
    includes: ['Visa', 'Ticket', 'Hotel', 'Transport', 'Meals'],
    featured: false,
  },
  {
    id: 2,
    name: 'Standard Umrah Package',
    arabic: 'باقة العمرة القياسية',
    type: 'Umrah',
    duration: '20 Days',
    description: '20-day Umrah with 4-star hotels. Full visa assistance, guided tours, Ziyarat visits to historic Islamic sites.',
    price: 'ETB 115,000',
    image: IMG.kaabaDay,
    includes: ['Visa', 'Ticket', '4★ Hotel', 'Transport', 'Meals', 'Guide'],
    featured: true,
  },
  {
    id: 3,
    name: 'VIP Umrah Package',
    arabic: 'باقة العمرة الفاخرة',
    type: 'Umrah',
    duration: '21 Days',
    description: 'Premium 21-day Umrah. 5-star hotels close to Haram, private transport, dedicated guide, priority Tawaf access.',
    price: 'ETB 195,000',
    image: IMG.kaabaNight,
    includes: ['Visa', 'Ticket', '5★ Hotel', 'Private Transport', 'Meals', 'Guide'],
    featured: false,
  },
  {
    id: 4,
    name: 'Ramadan Umrah Special',
    arabic: 'عمرة رمضان الخاصة',
    type: 'Umrah',
    duration: '14 Days',
    description: 'Experience the blessed nights of Ramadan in the Holy Land. Iftar and Suhoor included, hotels near Haram.',
    price: 'ETB 165,000',
    image: IMG.meccaNight,
    includes: ['Visa', 'Ticket', 'Hotel', 'Iftar', 'Suhoor', 'Transport'],
    featured: false,
  },

  {
    id: 6,
    name: 'Family Umrah Bundle',
    arabic: 'باقة العمرة العائلية',
    type: 'Umrah',
    duration: '18 Days',
    description: 'Designed for families of 4+. Connecting rooms, family-friendly meals, child-friendly transport, group rates.',
    price: 'ETB 110,000/person',
    image: IMG.mosqueInterior,
    includes: ['Visa', 'Ticket', 'Family Hotel', 'Transport', 'Meals'],
    featured: false,
  },
  {
    id: 7,
    name: "Children's Umrah Package",
    arabic: 'باقة عمرة الأطفال',
    type: 'Umrah',
    duration: '15 Days',
    description: 'Specially designed, discounted package for children traveling with their parents. Includes flight, visa, and dedicated child-friendly accommodations.',
    price: 'ETB 60,000',
    image: IMG.pilgrims,
    includes: ['Visa', 'Child Ticket', 'Hotel', 'Transport', 'Meals'],
    featured: false,
  },
  {
    id: 8,
    name: 'Umrah Visa Only',
    arabic: 'تأشيرة عمرة فقط',
    type: 'Visa',
    duration: 'Valid for 90 Days',
    description: 'Fast and reliable Umrah visa processing. Complete documentation assistance with high success rate.',
    price: 'ETB 40,000',
    image: IMG.kaabaDay,
    includes: ['Visa Processing', 'Documentation Support', 'Guidance'],
    featured: false,
  },
  {
    id: 9,
    name: 'Couple Package (Visa & Ticket)',
    arabic: 'باقة الزوجين (تأشيرة وتذكرة)',
    type: 'Visa & Flight',
    duration: 'Flexible',
    description: 'Perfect for couples. Includes Umrah Visas and round-trip flight tickets for two people.',
    price: 'ETB 230,000',
    image: IMG.kaabaNight,
    includes: ['Visa (x2)', 'Round-trip Ticket (x2)'],
    featured: false,
  },
];

export const SERVICES = [
  { id: '01', name: 'Visa Support', arabic: 'دعم التأشيرة', tag: 'Fast & Reliable', desc: 'Complete Umrah visa processing. Saudi, UAE, Schengen visas with full documentation assistance.', icon: 'Stamp' },
  { id: '02', name: 'Comfortable Hotels', arabic: 'فنادق مريحة', tag: 'Near Haram', desc: 'Premium hotels near Masjid al-Haram and Masjid an-Nabawi. All grades and budgets accommodated.', icon: 'Building' },
  { id: '03', name: 'Transport Facilities', arabic: 'خدمات النقل', tag: 'Door to Door', desc: 'Airport transfers, intercity transport between holy cities, and full group logistics management.', icon: 'Bus' },
  { id: '04', name: 'Delicious Meals', arabic: 'وجبات لذيذة', tag: 'Halal Certified', desc: 'Authentic halal meals throughout your journey. Ethiopian and Arabian cuisine options available.', icon: 'Utensils' },
  { id: '05', name: '24/7 Support', arabic: 'دعم 24/7', tag: 'Always Available', desc: 'Round-the-clock customer support during your entire trip. We are with you every step of the way.', icon: 'Phone' },
  { id: '06', name: 'Flight Tickets', arabic: 'تذاكر الطيران', tag: 'Best Fares', desc: 'Domestic and international tickets to Saudi Arabia, UAE, Turkey, and worldwide destinations.', icon: 'Plane' },
  { id: '07', name: 'Global Umrah Services', arabic: 'خدمات العمرة العالمية', tag: 'USA, CA & EU', desc: 'Dedicated visa and hotel booking services for travelers arriving from Canada, USA, and Europe. Travel comfortably on your own terms.', icon: 'Globe' },
];

export const TESTIMONIALS = [
  {
    quote: `Alhamdulillah, ${brandConfig.companyName} arranged our family Umrah perfectly. Visa, tickets, hotel — everything was flawless. We will always trust them for our sacred journeys.`,
    arabic: 'الحمد لله، رتبت هجرة تورز عمرتنا بشكل مثالي.',
    name: 'Hajja Fatima Ahmed',
    package: 'Standard Umrah Package',
  },
  {
    quote: 'Subhanallah, the VIP package was worth every birr. The hotel was steps from Masjid al-Haram. Team handled everything with love and professionalism.',
    arabic: 'سبحان الله، الباقة الفاخرة تستحق كل قرش. الفريق محترف.',
    name: 'Ato Mohammed Ibrahim',
    package: 'VIP Umrah Package',
  },
  {
    quote: `I have done Umrah 3 times through ${brandConfig.companyName}. Each time better than the last. Their 24/7 support means I can always reach them. Truly trusted.`,
    arabic: 'اعتمرت 3 مرات معهم. في كل مرة أفضل من السابقة. موثوقون حقاً.',
    name: 'Hajj Yusuf Abdella',
    package: 'Ramadan Umrah Special',
  },
];

export const STATS = [
  { value: 5000, suffix: '+', label: 'Pilgrims Served', arabic: 'حجاج ومعتمرين' },
  { value: 15, suffix: '+', label: 'Years of Service', arabic: 'سنوات من الخدمة' },
  { value: 24, suffix: '/7', label: 'Always Available', arabic: 'دائماً متاح' },
  { value: 100, suffix: '%', label: 'Visa Success Rate', arabic: 'نسبة النجاح' },
];

export const GALLERY_IMAGES = [
  IMG.kaabaNight,
  IMG.nabawi,
  IMG.pilgrims,
  IMG.mosqueInterior,
  IMG.meccaNight,
];

export const HERO_IMAGE = 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1920&h=1080&fit=crop&q=80';
export const CTA_IMAGE = 'https://images.unsplash.com/photo-1592326871020-04f58c1a52f3?w=1920&h=600&fit=crop&q=80';
export const SECONDARY_IMAGES = IMG;
